import { ResultTypeFrom } from '@reduxjs/toolkit/query';
import { Optional } from '@direct-frontend/stdlib';
import { useCallback } from 'react';
import { BaseRowData, EndpointDataProviderRowsGenerator, RequestedChunks } from '../../types';
import { AnyQueryDefinition, UseQueryStateDefaultResult } from '../../../apiSSRModule';
import { iterateOverChunks } from '../iterateOverChunks/iterateOverChunks';

export function useLoadedRows<Definition extends AnyQueryDefinition, RowData extends BaseRowData>(
    requestedChunks: RequestedChunks<Definition>,
    cachedValues: UseQueryStateDefaultResult<Definition>[],
    getRowByIndex: (chunkData: ResultTypeFrom<Definition>, rowIndexInChunk: number) => Optional<RowData>,
    chunkLength: number
): (
    ...args: Parameters<EndpointDataProviderRowsGenerator<RowData>['getLoadedRows']>
) => ReturnType<EndpointDataProviderRowsGenerator<RowData>['getLoadedRows']> {
    return useCallback(() => {
        const result: Array<NonNullable<ReturnType<typeof getRowByIndex>>> = [];

        iterateOverChunks(
            requestedChunks,
            cachedValues,
            rowData => {
                result.push(rowData);
            },
            {
                chunkLength,
                getRowByIndex,
            }
        );

        return result;
    }, [requestedChunks, cachedValues, getRowByIndex, chunkLength]);
}
